import React from 'react';
import classNames from 'classnames';

export interface SlidingButton {
	title: string;
	subtitle?: string;
	icon?: React.ReactNode;
	onClick?: () => void;
}

interface SlidingButtonGroupProps {
	activeButton: number;
	slidingButtons: SlidingButton[];
}

export default function SlidingButtonGroup({
	activeButton,
	slidingButtons,
}: SlidingButtonGroupProps) {
	return (
		<div className="sliding-button-group" data-testid="sliding-button-group">
			<div
				className={`sliding-button-background active-button-${activeButton}`}
				style={{
					width: `${100 / slidingButtons.length}%`,
					transform: `translateX(${activeButton * 100}%)`,
				}}
			/>
			{slidingButtons.map(({
				title,
				subtitle,
				icon,
				onClick,
			}, index) => (
				<button
					key={index}
					onClick={onClick}
					className={classNames(
						'sliding-button',
						{ 'sliding-button--active': index === activeButton },
					)}
				>
					{icon && (
						<div className="sliding-button-icon">
							{icon}
						</div>
					)}
					<div className="sliding-button-text">
						<h5 className="bl-font-header">{title}</h5>
						{subtitle && <p className="bl-font-s2">{subtitle}</p>}
					</div>
				</button>
			))}
		</div>
	);
}
